module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAdCAYAAAAgqdWEAAAAkElEQVRYR+2V0QmAMBBDkxFcQGfUQXRG3cAFjIgKWiqcKAiSfh/X9DWXI14+knoA5bEtSUauCRVFGu01FnNFy2RM5s4kLbX/8YwkJa/vSDZ3ibySMxazeqsFUJ/WxldkLGb5htzW/g8ZSUUy7hPJMY2AaOg9IpMx+kCyshiTAZDdTSZjMls+MLoo7Rl7ZvPMDM+rYOV9vNNGAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xue.png
// module id = /Eu7
// module chunks = 1